import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CanActivate } from '@angular/router';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { Console } from 'console';

@Injectable()
export class ValidarLogin implements CanActivate {

    paramLogin: string;

    constructor(
        private msalService: MsalUserService, 
        private router: Router,
        private activeRoute: ActivatedRoute) { }

    canActivate() {        
        return true
    }
}